import { HttpTimeoutError } from '@cian/peperrors/shared';

import { onlineStatusReceived } from 'shared/actions/chat';
import { ResponseError } from 'shared/errors/responseError';
import { fetchGetUserStatusById, TGetUserStatusByIdResponse } from 'shared/repositories/chats/v1/get-user-status-by-id';

import { IThunkActionCreator } from '../../store';

export function getUserChatOnlineStatus(): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger, telemetry }): Promise<void> => {
    const state = getState();
    const {
      offer: { userId },
    } = state.offerData;

    try {
      const { response, statusCode }: TGetUserStatusByIdResponse = await fetchGetUserStatusById({
        httpApi,
        parameters: { userId: userId as number },
      });

      if (statusCode !== 200) {
        throw new ResponseError({
          domain: 'src/shared/services/chats/getUserChatOnlineStatus.ts#getUserChatOnlineStatus',
          message: response.message || 'Неизвестная ошибка',
          details: {
            error: JSON.stringify(response.errors),
          },
        });
      }

      dispatch(onlineStatusReceived(response.online || false));
    } catch (error) {
      if (HttpTimeoutError.is(error)) {
        telemetry.increment('chats_timeout_online_status');
      }

      dispatch(onlineStatusReceived(false));

      logger.warning(error, {
        degradation: 'Не удалось получить статус пользователя в чате (онлайн/офлайн)',
      });
    }
  };
}
